import { erc721 } from '@jdiyield/abi'
import { ChainID } from '@jdiyield/constants'
import { NFTResult, Platform } from '@jdiyield/interfaces'
import { api, checkIPFS } from '@jdiyield/utils'
import Web3 from 'web3'

import { getAxieInfinity } from './platforms/axies'
import { getGalaxyNFT } from './platforms/galaxy'
import { getNFTOpenSea } from './platforms/opensea'
import { makeBatchRequest } from './utils'

export async function queryNFT(
  web3: Web3,
  account: string,
  platform: Platform,
  _chainID: ChainID
): Promise<NFTResult[]> {
  if (!platform.nftConfigs || platform.nftConfigs.length === 0) return []

  if (platform.name === 'OpenSea ETH') {
    return await getNFTOpenSea(account)
  }

  const result = await Promise.all(
    platform.nftConfigs.flatMap(async ({ contractAddress }) => {
      try {
        if (contractAddress === '0xe85d7b8f4c0c13806e158a1c9d7dcb33140cdc46') {
          return await getGalaxyNFT(account)
        }
        if (contractAddress === '0x32950db2a7164ae833121501c797d79e7b79d74c') {
          //AXIE
          return await getAxieInfinity(account)
        }
        //? ERC1155
        // const contract = new web3.eth.Contract(erc1155 as any, contractAddress)
        // const length = await contract.methods.balanceOf(account).call()
        // console.log('length', length)
        // //?ERC721
        const contract = new web3.eth.Contract(erc721 as any, contractAddress)
        const length = await contract.methods.balanceOf(account).call()
        const tokenIDs = await makeBatchRequest(
          web3,
          [...new Array(+length)].map((_, index) => contract.methods.tokenOfOwnerByIndex(account, `${index}`).call)
        )
        const tokenURIs = await makeBatchRequest(
          web3,
          tokenIDs.map((tokenID) => contract.methods.tokenURI(tokenID).call)
        )
        const result = await Promise.all(
          tokenURIs.map(async (tokenURI) => {
            const { data } = await api.get(checkIPFS(tokenURI))
            if (platform.name === 'treasureland BSC') {
              return {
                name: data?.data?.name,
                asset_url: data?.data?.image,
                thumbnail_url: data?.data?.thumb || data?.data?.image,
                asset_type: data?.data?.image_type
              } as NFTResult
            }
            return {
              name: data.name,
              asset_url: data?.original || data?.image,
              thumbnail_url: data?.image,
              asset_type: data?.type || (['mp4', 'mov'].includes(data?.image?.slice(-3)) ? 'video' : 'image'),
              link: data?.external_url
            } as NFTResult
          })
        )
        return result
      } catch (error) {
        console.log(error)
        return []
      }
    })
  )
  return result.flat() as NFTResult[]
}
